import React, { useContext, useState } from 'react'
import { PIMCORE_URL, ENDPOINTS } from '../../constants'
import { navigate } from 'gatsby'
import AppContext from '../context/app'
import useGetAllBuilderProducts from '../hooks/useGetAllBuilderProducts'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Carousel from 'react-bootstrap/Carousel'
import Spinner from 'react-bootstrap/Spinner'
import getCartId from '../utilities/get-cart-id'

export default function FreeCheckout(props) {
    const { setShowFreeCheckout } = props
    
    const value = useContext(AppContext)
    const { cart, cartId, country } = value
    
    const allProduct = useGetAllBuilderProducts()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const handleSubmit = async (e) => {
        e.preventDefault()
        e.stopPropagation()

        const form = e.target
        const email = form.email.value
        const firstname = form.firstname.value
        const lastname = form.lastname.value

        setLoading(true)
        const r = await fetch(`${PIMCORE_URL}${ENDPOINTS.REGISTER_PRODUCT(country?.node.country_iso_code)}`, {
            method: 'post',
            body: JSON.stringify({
                session_cart_id: cartId,
                customer_detail: {
                    email,
                    firstname,
                    lastname,
                }
            })
        })
        setLoading(false)

        const { success, order_number } = await r.json()
        if (success) {
            await getCartId(value)
            setShowFreeCheckout(false)
            await navigate('/registered', {
                state: {
                    email,
                    firstname,
                    lastname,
                    order_number,
                    cart
                }
            })
        } else {
            setError(order_number)
        }
    }

    const property = process.env.GATSBY_ENVIRONMENT_PRODUCTION === 'true' ?
        'pimcoreProductionId' : 
        'pimcoreStagingId'

    return (
        <Container className='pt-3'>
            <Row className='align-items-center'>
                <Col md={6} className='text-center'>
                    <p className='ff-primary text-uppercase fw-bold' style={{ fontSize: 32 }}>
                        Congrats on<br /> your free product{cart?.items.length > 1 ? 's' : ''}:
                    </p>
                    <Carousel
                        controls={cart?.items.length > 1}
                        indicators={cart?.items.length > 1}
                        prevIcon={<img src='/svg/chevron-right-black.svg' alt='' style={{ rotate: '180deg' }} />}
                        nextIcon={<img src='/svg/chevron-right-black.svg' alt='' />}
                    >
                        {cart?.items.map(item => {
                            const { product_id, product_name } = item
                            const product = allProduct.find(product => Number(product_id) === Number(product[property]))
                            
                            const { image } = product || {}
                            if(!image) return

                            return (
                                <Carousel.Item className='position-relative'>
                                    <img
                                        src={image}
                                        alt={product_name}
                                        className=''
                                        style={{ width: 500 }}
                                        objectFit='contain'
                                    />
                                </Carousel.Item>
                            )
                        })}
                    </Carousel>
                </Col>
                <Col>
                    <p className='ff-primary fw-bold' style={{ fontSize: 32 }}>
                        Register with inMusic Profile
                    </p>
                    {error && <p className='text-danger'>{error}</p>}
                    <Form onSubmit={handleSubmit}>
                        <Form.Control required type='text' placeholder='First name' name='firstname' className='mb-2' pattern="[A-Za-z ]{1,32}" />
                        <Form.Control required type='text' placeholder='Last name' name='lastname' className='mb-2' pattern="[A-Za-z ]{1,32}" />
                        <Form.Control required type='email' placeholder='Email address' name='email' className='mb-2' />
                        <Form.Text>Please provide your sign on credentials for your inMusic Profile account so that we can add the product to your profile. If you don't have an inMusic profile account, one will be made for you and you'll get an email detailing how to get access.</Form.Text>
                        
                        <div className='d-flex gap-2 mt-3'>
                            <Button
                                variant='outline-dark'
                                className='w-100'
                                style={{ maxWidth: 200 }}
                                onClick={() => setShowFreeCheckout(false)}
                            >
                                Back to cart
                            </Button>
                            <Button
                                type='submit'
                                variant='primary'
                                className='w-100'
                                style={{ maxWidth: 200 }}
                            >
                                {
                                    loading ?
                                        <Spinner animation="border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </Spinner>
                                        :
                                        'Submit'
                                }
                            </Button>
                        </div>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}